// console.log(location.href);

// Detect development mode
const isDevelopment = window.location.hostname === 'localhost' ||
                     window.location.hostname === '127.0.0.1' ||
                     window.location.port === '444';

// Dynamic configuration based on environment
const baseUrl =  "https://fikoyt.com";

export var FikoYTEnvIstemci: any = {
    uygulamaIsmi: "fikoyt.com",
    firmaAdi: "FikoYT Sistem",
    firmaResimUrlKok: "",
    firmaResimYokUrl: "",
    firmaResimHazirlaniyorUrl: "",

    solMenuGenislik: '230px',

    logoKucuk: "/resimler/logo-kucuk.png",
    logoBuyuk: "/resimler/logo-buyuk.png",

    logoSimge: "/resimler/logo.png",

    languages: [
        { title: '🇹🇷 Türkçe', code: 'tr' },
        { title: '🇬🇧 English', code: 'en' },
    ],

    paraBirimleri: {
        0: "₺",
        2: "$",
        3: "£",
        8: "€",
    },

    adres: {
        url: baseUrl,
        sunucuUrl: baseUrl + ":9000",
        port: 444,
        fapiPort: 9000,
        fapiUrl: baseUrl + ":9000/fapiv1",

        options: {
            autoConnect: true,
            'sync disconnect on unload': true,
            transports: ['websocket'],
            upgrade: true,
            secure: true,
            reconnect: true,
            closeOnBeforeunload: true,
            rejectUnauthorized: false,
            withCredentials: true,
        },

        sabitUrller: {
            giris: {
                girisUrl: "/🏠/🏛",
                girisVarsayilanUrl: "/🏠/🏛",
                girisVarsayilanUrlList: ['/👨', "🏠"],
            },
            admin: {
                varsayilanUrl: "/💎/🏠",
                varsayilanUrlList: ['/💎', "🏠"],
            },
            uye: {
                uyeVarsayilanUrl: "/🏠/🏛",
                uyeVarsayilanUrlList: ['/👨', "🏠"],
            }
        },
        serverUrller: {
            girisYap: "giris.giris-yap",
            cikisYap: "giris.cikis-yap",
            girisYapilmisMi: "giris.girisYapilmisMi",
            bildirimler: {
                kaydet: "merkur.b2b.bildirimler.push-kaydet",
                cihazlar: "merkur.b2b.bildirimler.cihazlar",
                yolla: "merkur.b2b.bildirimler.yolla",
            },
        },
    },
    cache: {
        maxAge: 86400 * 10,// NOT: : 10 Gün
        imageCache: "public, max-age=86400",
    },
    serviceWorkerAcik: false,
    /** */
    altYazi: "⭕ FikoYT Sistem ⭕",
    sayfaBaslik: "FikoYT Sistem",
}
